import styled, { css } from 'styled-components';

export const FiltersWrapper = styled.div`
  padding-top: 2px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  margin-bottom: 24px;

  #filter-groups {
    order: 1;
  }

  #filter-ffoo {
    order: 2;
  }

  #filter-user_work_role {
    order: 3;
  }

  #filter-regions {
    order: 4;
  }

  #filter-provinces {
    order: 5;
  }

  #filter-time-interval {
    order: 6;
  }

  #cta-search {
    order: 7;
  }
`;

export const SortingWrapper = styled.div`
  margin-block: 24px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  > div:last-child {
    height: 48px;
  }
`;

const gridTableCol = css`
  --padding-inline: 32px;

  display: grid;
  grid-template-columns: 1.5fr repeat(6, 1fr);
  column-gap: 24px;
  padding-inline: var(--padding-inline);
`;

export const Legend = styled.div`
  ${gridTableCol}
  margin-bottom: 24px;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }

  > *:last-child {
    margin-right: calc(var(--padding-inline) * -1);
  }
`;

export const UserCard = styled.div`
  ${gridTableCol}
  align-items: center;
  padding-block: 24px;
  //height: 73px;
  margin-bottom: 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
`;
